import { ReactLenis } from "lenis/react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import FreeGuide from "@/pages/FreeGuide";
import ThankYou from "@/pages/ThankYou";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <BrowserRouter>
        <div className="App" data-testid="app-root">
          <div className="grain-overlay" />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/free-guide" element={<FreeGuide />} />
            <Route path="/thank-you" element={<ThankYou />} />
          </Routes>
          <Footer />
          <Toaster position="bottom-right" theme="dark" />
        </div>
      </BrowserRouter>
    </ReactLenis>
  );
}

export default App;
